import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Discussion, VoterListConfig } from "../../../../models";

@Component({
  selector: "voter-list-modal",
  templateUrl: "./voter-list-modal.component.html",
  styleUrls: [
    "./voter-list-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VoterListModal implements OnInit {
  // list component inputs
  @Input() discussion: Discussion;
  @Input() limit: number;
  @Input() config: VoterListConfig;

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
